const MODULE_NAME = 'PAYMENT'

export const PURCHASE = `${MODULE_NAME}/PURCHASE`
export const PRIMER_PURCHASE_PROCESSING = `${MODULE_NAME}/PRIMER_PURCHASE_PROCESSING`
export const CHECK_3D_SECURE = `${MODULE_NAME}/CHECK_3D_SECURE`
export const SET_3D_SECURE_IFRAME_URL = `${MODULE_NAME}/SET_3D_SECURE_IFRAME_URL`
export const RESET_3D_SECURE_IFRAME_URL = `${MODULE_NAME}/RESET_3D_SECURE_IFRAME_URL`
export const SET_STRIPE_CLIENT_SECRET = `${MODULE_NAME}/SET_STRIPE_CLIENT_SECRET`
export const SET_STRIPE_QUICK_PAY_METHOD = `${MODULE_NAME}/SET_STRIPE_QUICK_PAY_METHOD`
export const SET_STRIPE_QUICK_PAY_CHECKED = `${MODULE_NAME}/SET_STRIPE_QUICK_PAY_CHECKED`
export const SET_IS_PRIMER_RETRY_PROCESSING = `${MODULE_NAME}/SET_IS_PRIMER_RETRY_PROCESSING`
export const SET_IS_FIRST_PAYMENT_RETRY_PASSED = `${MODULE_NAME}/SET_IS_FIRST_PAYMENT_RETRY_PASSED`
export const MAKE_UPSELL = `${MODULE_NAME}/MAKE_UPSELL`
export const UPDATE_PRIMER_CLIENT_SESSION = `${MODULE_NAME}/UPDATE_PRIMER_CLIENT_SESSION`
export const SET_PRIMER_CLIENT_TOKEN = `${MODULE_NAME}/SET_PRIMER_CLIENT_TOKEN`
export const GET_PRIMER_CLIENT_SESSION_TOKEN = `${MODULE_NAME}/GET_PRIMER_CLIENT_SESSION_TOKEN`
export const SET_PAYMENT_CONFIG = `${MODULE_NAME}/SET_PAYMENT_CONFIG`
export const GET_PAYMENT_CONFIG = `${MODULE_NAME}/GET_PAYMENT_CONFIG`
export const SET_IS_SUBSCRIPTION_PURCHASE_INITIATED = `${MODULE_NAME}/SET_IS_SUBSCRIPTION_PURCHASE_INITIATED`
export const SET_IS_ALREADY_BOUGHT = `${MODULE_NAME}/SET_IS_ALREADY_BOUGHT`
export const SET_IS_FORCE_3DS = `${MODULE_NAME}/SET_IS_FORCE_3DS`
export const SET_PAYMENT_PROCESSOR_NAMES = `${MODULE_NAME}/SET_PAYMENT_PROCESSOR_NAMES`
export const SET_IS_DIRECT_STRIPE_PAYMENT_ENABLED = `${MODULE_NAME}/SET_IS_DIRECT_STRIPE_PAYMENT_ENABLED`
